import { Avatar, Box, CircularProgress, Grid, Typography } from "@mui/material";
import {
  ActivityQueryFiltersDtoTypeEnum,
  GetTicketChangeLogDTOActionEnum,
} from "../../../api-client";
import { useFetchTicketActivities, useAddComment } from "../../../stores/Ticketing";
import { ArrowRightAlt } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import React, { useState } from "react";
import { format } from "date-fns";
import { Timeline, TimelineEvent } from "react-event-timeline";
import { MobiliAvatar } from "../../../atoms/MobiliAvatar";
import CommentInput from "./CommentInput";

const AllActivityTicket: React.FC<{ selectedTicketId: number }> = ({
  selectedTicketId,
  // setTicketData: any,
}) => {
  const [newCommentText, setNewCommentText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const addComment = useAddComment();

  const handleSubmit = async () => {
    try {
      if (!selectedTicketId || !newCommentText.trim()) return;
      
      const response = await addComment.mutateAsync({
        ticketId: selectedTicketId,
        commentData: { comment: newCommentText },
      });
      
      if (response) {
        setNewCommentText("");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleEmojiSelect = (emoji: any) => {
    if (emoji && emoji.emoji) {
      setNewCommentText((prevText) => prevText + emoji.emoji);
    }
    setShowEmojiPicker(false);
  };

  const {
    data: allActivities,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFetchTicketActivities({
    limit: 10,
    type: [ActivityQueryFiltersDtoTypeEnum.History, ActivityQueryFiltersDtoTypeEnum.Comments],
    ticketId: selectedTicketId,
  });

  const fetchedAllActivitiesCount =
    allActivities?.pages.reduce((total, page) => total + page.length, 0) || 0;

  return (
    <Box sx={{ 
      height: '500px', 
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <Box
        id="scrollableAllActivityDiv"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: '90px',
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: 1,
        }}
      >
      {selectedTicketId && (
        <Timeline>
          <InfiniteScroll
            dataLength={fetchedAllActivitiesCount}
            next={() => {
              fetchNextPage();
            }}
            hasMore={!!hasNextPage}
            loader={
              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <CircularProgress size={24} color="inherit" />
              </Box>
            }
            scrollableTarget="scrollableAllActivityDiv"
          >
            {selectedTicketId &&
              allActivities &&
              allActivities?.pages.map((page, index: any) =>
                page.map((activity) => (
                  <React.Fragment key={activity.id}>
                    {activity.text && (
                      // activity.text?.map((textItem: any, textIndex: any) => (

                      // ))
                      <TimelineEvent
                        //key={`${index}-${textIndex}`}
                        title={` ${activity.text?.changeMessage}`}
                        createdAt={
                          <div style={{ textAlign: "right" }}>
                            {activity?.text?.createdAt &&
                              format(new Date(activity?.text?.createdAt), "dd.MM.yyyy, HH:mm")}
                          </div>
                        }
                        icon={
                          activity.text.updatedByUser && (
                            <MobiliAvatar
                              user={activity.text.updatedByUser}
                              sx={{ width: 32, height: 32, fontSize: "0.8rem" }}
                            />
                          )
                        }
                      >
                        {activity.text?.action?.toLowerCase() !==
                          GetTicketChangeLogDTOActionEnum.Created?.toLowerCase() && (
                          <Typography variant="body2">
                            <Box display="flex" alignItems="center">
                              {activity.text.previous && (
                                <>
                                  {activity.text.previous}{" "}
                                  <ArrowRightAlt fontSize="medium" sx={{ mx: 1 }} />
                                </>
                              )}
                              {activity.text.current}
                            </Box>
                          </Typography>
                        )}
                      </TimelineEvent>
                    )}
                  </React.Fragment>
                ))
              )}
          </InfiniteScroll>
        </Timeline>
      )}
      </Box>

      <CommentInput
        newCommentText={newCommentText}
        setNewCommentText={setNewCommentText}
        onSubmit={handleSubmit}
        showEmojiPicker={showEmojiPicker}
        setShowEmojiPicker={setShowEmojiPicker}
        onEmojiSelect={handleEmojiSelect}
      />
    </Box>
  );
};
export default AllActivityTicket;
